module.exports = __webpack_public_path__ + "static/media/javascript-fullstack.730958a2.jpg";